import PropTypes from "prop-types"
import React from "react"
import Navigation from "./navigation"
import scrollTo from "gatsby-plugin-smoothscroll"
import weefLogo from "../assets/svg/WEEF.svg"

// import style from '../components/header.module.scss'

const Header = ({ siteTitle }) => (
  <header
    style={{
      // background: "grey",
      position: `fixed`,
      width: "100vw",
      height: "fit-content(0)",
      boxSizing: "border-box",
      padding: `3rem 5rem`,
      display: "flex",
      justifyContent: "space-between",
      zIndex: "1000",
      pointerEvents: "none",
    }}
  >
    <img
      src={weefLogo}
      style={{
        zIndex: "1",
        maxWidth: "10rem",
        pointerEvents: "visible",
        cursor: "pointer",
      }}
      onClick={() => scrollTo("#landing")}
      alt="weef_logo"
    ></img>
    <Navigation
      links={[
        "wat is weef",
        "geschiedenis",
        "kunstenaars",
        "resultaat",
        "contact",
      ]}
    ></Navigation>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
